import { createSlice, Reducer } from '@reduxjs/toolkit';

import { APPLICATION_SLICE_NAME, APPLICATION_INITIAL_STATE } from './consts';
import type { ApplicationState } from './types';

const applicationSlice = createSlice({
  name: APPLICATION_SLICE_NAME,
  initialState: APPLICATION_INITIAL_STATE,
  reducers: {
    setAppInitialized: (state) => {
      state.appInitialized = true;
    },
  },
});

export const { setAppInitialized } = applicationSlice.actions;

export const applicationReducer: Reducer<ApplicationState> = applicationSlice.reducer;
